/* eslint-disable no-throw-literal */
import * as Api from '../lib/Api'
import { loadingActions } from '../store/loading'
import { store } from '../store'
import { login } from './AuthService'

export const updateAccountSettings = async params => {
  store.dispatch(loadingActions.show())
  try {
    await Api.updateAccountSettings(params)
  } catch (error) {
    store.dispatch(loadingActions.hide())
    throw error.message
  }
  store.dispatch(loadingActions.hide())
}

export const createClientUser = async (
  accessCode,
  firstName,
  lastName,
  email,
  phone,
  username,
  photoUrl,
  roles,
  role,
  password,
  employeeId,
  avoidEmail = false
) => {
  store.dispatch(loadingActions.show())
  try {
    await Api.createUser(
      {
        company_id: accessCode,
        firstName,
        lastName,
        email,
        roles,
        role,
        phone,
        photo_url: photoUrl,
        username,
        password,
        employee_id: employeeId
      },
      '1st'
    )
  } catch (error) {
    store.dispatch(loadingActions.hide())
    if (error.details?.details && error.details?.details[0]) {
      if (error.details.details[0].path.includes('email')) {
        throw error.details?.details[0].message
      }
      throw `${error.details?.details[0].path.substring(1)} ${
        error.details?.details[0].message
      }`
    }
    throw error.message
  }

  try {
    await Api.createUser(
      {
        company_id: accessCode,
        firstName,
        lastName,
        email,
        roles,
        role,
        phone,
        photo_url: photoUrl,
        username,
        password,
        employee_id: employeeId
      },
      '2nd'
    )
  } catch (error) {
    store.dispatch(loadingActions.hide())
    if (error.details?.details && error.details?.details) {
      throw `${error.details?.details[0].path.substring(1)} ${
        error.details?.details[0].message
      }`
    }
    throw error.message
  }

  let newUser = null
  try {
    newUser = await Api.createUser(
      {
        company_id: accessCode,
        firstName,
        lastName,
        email,
        roles,
        role,
        phone,
        photo_url: photoUrl,
        username,
        password,
        employee_id: employeeId,
        avoid_email: avoidEmail
      },
      'final'
    )
  } catch (error) {
    store.dispatch(loadingActions.hide())
    if (error.details?.details && error.details?.details) {
      throw `${error.details?.details[0].path.substring(1)} ${
        error.details?.details[0].message
      }`
    }
    throw error.message
  }

  store.dispatch(loadingActions.hide())
  return newUser
}

export const updateCompany = async (id, params) => {
  store.dispatch(loadingActions.show())
  try {
    const response = await Api.updateCompany(id, params)
    store.dispatch(loadingActions.hide())
    return response
  } catch (error) {
    store.dispatch(loadingActions.hide())
    throw error.message
  }
}

export const updateClientUser = async (id, params) => {
  store.dispatch(loadingActions.show())
  try {
    const response = await Api.updateUser(id, params)
    store.dispatch(loadingActions.hide())
    return response
  } catch (error) {
    store.dispatch(loadingActions.hide())
    throw error
  }
}

export const deleteUser = async (id, companyId) => {
  store.dispatch(loadingActions.show())
  try {
    const response = await Api.deleteUser(id, companyId)
    store.dispatch(loadingActions.hide())
    return response
  } catch (error) {
    store.dispatch(loadingActions.hide())
    throw error
  }
}

export const getCompanyRoles = async companyId => {
  store.dispatch(loadingActions.show())
  try {
    const companyRoles = await Api.getCompanyRoles(companyId)
    store.dispatch(loadingActions.hide())
    return companyRoles
  } catch (e) {
    store.dispatch(loadingActions.hide())
    throw e
  }
}

export const createUser = async (
  accessCode,
  firstName,
  lastName,
  email,
  title,
  username,
  password
) => {
  store.dispatch(loadingActions.show())
  try {
    await Api.createUser(
      {
        company_id: accessCode,
        firstName,
        lastName,
        email,
        role: title,
        username,
        password
      },
      '1st'
    )
  } catch (error) {
    store.dispatch(loadingActions.hide())
    if (error.details?.details && error.details?.details[0]) {
      if (error.details.details[0].path.includes('email')) {
        throw { type: 'email', message: error.details?.details[0].message }
      }
      throw {
        message: `${error.details?.details[0].path.substring(1)} ${
          error.details?.details[0].message
        }`
      }
    }
    throw { type: 'email', message: error.message }
  }

  try {
    await Api.createUser(
      {
        company_id: accessCode,
        firstName,
        lastName,
        email,
        role: title,
        username,
        password
      },
      '2nd'
    )
  } catch (error) {
    store.dispatch(loadingActions.hide())
    if (error.details?.details && error.details?.details) {
      throw {
        message: `${error.details?.details[0].path.substring(1)} ${
          error.details?.details[0].message
        }`
      }
    }
    throw { type: 'username', message: error.message }
  }

  try {
    await Api.createUser(
      {
        company_id: accessCode,
        firstName,
        lastName,
        email,
        role: title,
        username,
        password
      },
      'final'
    )
  } catch (error) {
    store.dispatch(loadingActions.hide())
    if (error.details?.details && error.details?.details) {
      throw {
        message: `${error.details?.details[0].path.substring(1)} ${
          error.details?.details[0].message
        }`
      }
    }
    throw { message: error.message }
  }

  // Login Process
  await login(email, password, '/')
  store.dispatch(loadingActions.hide())
}

export const getCompany = async id => {
  store.dispatch(loadingActions.show())
  try {
    const response = await Api.getCompany(id)
    store.dispatch(loadingActions.hide())
    return response
  } catch (err) {
    store.dispatch(loadingActions.hide())
    throw err
  }
}

export const getCompanyProfile = async id => {
  store.dispatch(loadingActions.show())
  try {
    const response = await Api.getCompanyProfile(id)
    store.dispatch(loadingActions.hide())
    return response
  } catch (err) {
    store.dispatch(loadingActions.hide())
    throw err
  }
}

export const getCompanyUsers = async companyId => {
  store.dispatch(loadingActions.show())
  try {
    const response = await Api.getCompanyUsers(companyId)
    store.dispatch(loadingActions.hide())
    return response
  } catch (err) {
    store.dispatch(loadingActions.hide())
    throw err
  }
}

export const changeUserPassword = async password => {
  store.dispatch(loadingActions.show())
  try {
    const response = await Api.changeUserPassword(password)
    store.dispatch(loadingActions.hide())
    return response
  } catch (err) {
    store.dispatch(loadingActions.hide())
    throw err
  }
}

export const getScreenConfigs = async (configId, page, limit, search) => {
  try {
    const screenConfigs = await Api.getScreenConfigs(configId, page, limit, search)

    return screenConfigs
  } catch (e) {
    console.error(e)
    throw e
  }
}

export const getTrades = async () => {
  try {
    const trades = await Api.getTrades()
    return trades
  } catch (e) {
    console.error(e)
    throw e
  }
}

export const getWorkOrderTypes = async () => {
  try {
    const wotypes = await Api.getWorkOrderTypes()
    return wotypes
  } catch (e) {
    console.error(e)
    throw e
  }
}

export const createScreenConfiguration = async data => {
  store.dispatch(loadingActions.show())
  try {
    const newScreenConfiguration = await Api.createScreenConfiguration(data)
    store.dispatch(loadingActions.hide())
    return newScreenConfiguration
  } catch (e) {
    store.dispatch(loadingActions.hide())
    throw e
  }
}
export const getUserAndRoles = async () => {
  store.dispatch(loadingActions.show())
  try {
    const user = await Api.getUser()
    const roles = await Api.getManagementRoles()
    const userRole = user?.roles
    const userRoleIndex = roles.findIndex(role => role.id === userRole)
    store.dispatch(loadingActions.hide())
    return { user, roles, userRoleIndex }
  } catch (e) {
    store.dispatch(loadingActions.hide())
    throw e
  }
}
export const updateScreenConfiguration = async (id, params) => {
  store.dispatch(loadingActions.show())
  try {
    const response = await Api.updateScreenConfiguration(id, params)
    store.dispatch(loadingActions.hide())
    return response
  } catch (error) {
    store.dispatch(loadingActions.hide())
    throw error.message
  }
}

export const getAudits = async id => {
  store.dispatch(loadingActions.auditTrailLoading(true))
  try {
    const response = await Api.getAudits(id)
    store.dispatch(loadingActions.auditTrailLoading(false))
    return response
  } catch (error) {
    store.dispatch(loadingActions.auditTrailLoading(false))
    throw error.message
  }
}

export const createAudit = async id => {
  store.dispatch(loadingActions.show())
  try {
    const response = await Api.createAudit(id)
    store.dispatch(loadingActions.hide())
    return response
  } catch (error) {
    store.dispatch(loadingActions.hide())
    throw error.message
  }
}

export const migrateAudits = async id => {
  store.dispatch(loadingActions.show())
  try {
    const response = await Api.migrateAudits(id)
    store.dispatch(loadingActions.hide())
    return response
  } catch (error) {
    store.dispatch(loadingActions.hide())
    throw error.message
  }
}

export const sendPortalInvitation = async (email, companyId) => {
  store.dispatch(loadingActions.show())
  try {
    const response = await Api.sendPortalInvitation(email, companyId)
    store.dispatch(loadingActions.hide())
    return response
  } catch (err) {
    store.dispatch(loadingActions.hide())
    throw err
  }
}
